/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


const visitWithCycleDetection = (object, permanent, temporary, sorted, getChildrenCallback) =>
{
  if (temporary.has(object))
  {
    return true;
  }

  if (!permanent.has(object))
  {
    temporary.add(object);

    for (let dependency of getChildrenCallback(object))
    {
      if (visitWithCycleDetection(dependency, permanent, temporary, sorted, getChildrenCallback))
      {
        return true;
      }
    }

    temporary.delete(object);
    permanent.add(object);
    sorted.push(object);
  }

  return false;
}


export const sort = (objects, getChildrenCallback) =>
{
  let sorted = [];
  let permanent = new Set();
  let temporary = new Set();

  for (const object of objects)
  {
    if (!permanent.has(object))
    {
      if (visitWithCycleDetection(object, permanent, temporary, sorted, getChildrenCallback))
      {
        throw new Error('Cannot sort in topological order - graph cycle found.');
      }
    }
  };

  return sorted.reverse();
}


export const hasCycle = (objects, getChildrenCallback) =>
{
  let permanent = new Set();
  let temporary = new Set();

  for (const object of objects)
  {
    if (!permanent.has(object))
    {
      if (visitWithCycleDetection(object, permanent, temporary, [], getChildrenCallback))
      {
        return true;
      }
    }
  }

  return false;
}
